module.exports = __webpack_public_path__ + "img/profile_box_gray_interests.575df9cf.svg";